var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.667 34.0013V47.3346H23.3337V34.0013M34.0003 47.3346V27.3346M34.0003 27.3346H28.0003C27.1163 27.3346 26.2684 26.9834 25.6433 26.3583C25.0182 25.7332 24.667 24.8854 24.667 24.0013C24.667 23.1172 25.0182 22.2694 25.6433 21.6443C26.2684 21.0192 27.1163 20.668 28.0003 20.668C32.667 20.668 34.0003 27.3346 34.0003 27.3346ZM34.0003 27.3346H40.0003C40.8844 27.3346 41.7322 26.9834 42.3573 26.3583C42.9825 25.7332 43.3337 24.8854 43.3337 24.0013C43.3337 23.1172 42.9825 22.2694 42.3573 21.6443C41.7322 21.0192 40.8844 20.668 40.0003 20.668C35.3337 20.668 34.0003 27.3346 34.0003 27.3346ZM20.667 27.3346H47.3337V34.0013H20.667V27.3346Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.21a862521bd9dc501046090424da4bdb.svg";
export { ForwardRef as ReactComponent };